import React from 'react';
import { useTranslation } from 'react-i18next';
import { WarningCircle } from '@phosphor-icons/react';
import { getApiToken } from '../../../../context/AuthContext';
import { getLoginAsBehalfFromToken } from '../../../../utils/jwt';
import { useUserInfo } from '../../context/UserInfo';
import './LoginAsBanner.css';

/* eslint-disable no-unused-vars */
enum EmployeeSessionUserType {
  SF_USER = 'SF_USER',
  EMPLOYEE = 'EMPLOYEE',
}

const LoginAsBanner: React.FC = () => {
  const { t } = useTranslation();
  const apiToken = getApiToken();
  const loginAsInfo = getLoginAsBehalfFromToken(apiToken);
  const { name: employeeName } = useUserInfo();

  if (!loginAsInfo || loginAsInfo.type !== EmployeeSessionUserType.SF_USER) {
    return null;
  }

  return (
    <div className="login-as-banner-container">
      <WarningCircle size={16} weight="fill" />
      {t('dashboard.loginAsBanner', { employeeName })}
    </div>
  );
};

export default LoginAsBanner;
